<script>
import Multiselect from 'vue-multiselect'

export default {

    components: { Multiselect },

    props: {

    },

    data() {
        return {
            trackBy: 'id',

            provider: null,
            initProvider: [],
            providers_option: [],

            language: null,
            initLanguages: [],
            languages_option: [],
        }
    },

    watch: {
        initProvider: {
            immediate: true,
            handler(values) {
                this.provider = this.providers_option.filter(x => values.includes(x['operator_uuid']));
                this.provider = this.provider[0];
            }
        },
        initLanguages: {
            immediate: true,
            handler(values) {
                this.language = this.languages_option.filter(x => values.includes(x[this.trackBy]));
                this.language = this.language[0];
            }
        },
        provider: {
            immediate: true,
            async handler(values) {

                if(this.provider){
                    this.$parent.stt_params.provider = this.provider.operator_code ? this.provider.operator_code : null;
                    this.$parent.stt_params.provider_uuid = this.provider.operator_uuid ? this.provider.operator_uuid : null;

                    let filter = {
                        'operator_uuid' : this.$parent.stt_params.provider_uuid,
                        'product_code'  : this.$parent.stt_params.product_code,
                    }
                    let data_send = {
                        'where' : JSON.stringify(filter)
                    }

                    await this.$store.dispatch('operatorsTariffs/FETCH_OPERATORS_TARIFFS_LIST', data_send);
                    if(this.operators_tariffs_list_data && this.operators_tariffs_list_data[0]){
                        this.languages_option = this.get_options(this.operators_tariffs_list_data[0].languages);
                        this.initLanguages = [this.$parent.stt_params.language];
                    }

                } else if(values === null) {
                    this.voices_id_option = [];
                    this.languages_option = [];
                    this.language = null;
                    this.$parent.stt_params.provider = null;
                    this.$parent.stt_params.provider_uuid = null
                }
            }
        },
        language: {
            immediate: true,
            handler(values) {
                if(this.language && this.language.id) {
                    this.$parent.stt_params.language = this.language.id ? this.language.id : null;
                } else if(values === null) {
                    this.$parent.stt_params.language = null;
                }
            }
        },
    },

    computed: {
        operators_tariffs_list_data(){
            return this.$store.getters['operatorsTariffs/GET_OPERATORS_TARIFFS_LIST_DATA'];
        },
    },

    async mounted() {
        let data_send = {
            'filter'     : this.$parent.params.stt_params.product_code ? this.$parent.params.stt_params.product_code : this.$parent.stt_params.product_code,
            'filterOn'   : JSON.stringify(['product_code']),
            'get_fields' : JSON.stringify(['operator_code', 'operator_name', 'operator_uuid', 'product_code']),
            'groupBy'    : JSON.stringify(['operator_code', 'operator_name', 'operator_uuid', 'product_code']),
        }

        await this.$store.dispatch('operatorsTariffs/FETCH_OPERATORS_TARIFFS_LIST', data_send);

        this.providers_option = this.operators_tariffs_list_data;

        if(this.$parent.params.stt_params && this.$parent.params.stt_params.provider_uuid) {
            this.initProvider = [this.$parent.params.stt_params.provider_uuid];
        }
    },

    methods: {
        get_options(arr = []){
            let arr_options = [];
            let name_translate = {
                'ru-RU' : 'Русский',
                'kk-KK' : 'Казахский',
                'de-DE'	: 'Немецкий',
                'en-US'	: 'Английский',
                'es-ES'	: 'Испанский',
                'fi-FI'	: 'Финский',
                'fr-FR'	: 'Французский',
                'it-IT'	: 'Итальянский',
                'nl-NL'	: 'Голландский',
                'pl-PL'	: 'Польский',
                'pt-PT'	: 'Португальский',
                'pt-BR'	: 'Бразильский португальский',
                'sv-SE'	: 'Шведский',
                'tr-TR'	: 'Турецкий'
            }
            arr.forEach(el => {
                arr_options.push({
                    id: el,
                    name: name_translate[el] ? name_translate[el] : el
                });
            })
            return arr_options;
        }
    }
}
</script>

<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <b-form-group
                    label="Переменная для результата"
                    label-for="stt_params_variable_name"
                >
                    <b-form-input
                        id="stt_params_variable_name"
                        v-model="$parent.record.variable_name"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-sm-12 col-xl-6">
                <b-form-group
                    label="Ожидать начало ввода (сек)"
                    label-for="record_max_silence_begin"
                >
                    <b-form-input
                        id="record_max_silence_begin"
                        v-model="$parent.record.max_silence_begin"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-sm-12 col-xl-6">
                <b-form-group
                    label="окончание ввода (сек)"
                    label-for="record_max_silence_end"
                >
                    <b-form-input
                        id="record_max_silence_end"
                        v-model="$parent.record.max_silence_end"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-sm-12 col-xl-12">
                <b-form-group
                    label="Максимальная длительность записи (сек)"
                    label-for="max_duration"
                >
                    <b-form-input
                        id="max_duration"
                        v-model="$parent.record.max_duration"
                    ></b-form-input>
                </b-form-group>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 col-xl-12">
                <b-form-checkbox v-model="$parent.stt_params.async_action" name="config_stt_params" style="margin-top: 15px; margin-bottom: 5px" switch>
                    Асинхронное распознавание ответа
                </b-form-checkbox>
            </div>
        </div>

        <div v-show="$parent.stt_params.async_action" class="row" style="margin-top: 15px">
            <div class="col-sm-12 col-xl-12">
                <b-form-group
                    label="Переменная для результата"
                    label-for="stt_params_variable_name"
                >
                    <b-form-input
                        id="stt_params_variable_name"
                        v-model="$parent.stt_params.variable_name"
                    ></b-form-input>
                </b-form-group>
            </div>

            <div class="col-sm-12 col-xl-12">
                <b-form-group
                    label="Провайдер"
                    label-for="provider"
                >
                    <multiselect
                        id="provider"
                        v-model="provider"
                        :options="providers_option"
                        placeholder="Выберите из списка"
                        selectLabel="Нажмите, чтобы выбрать"
                        deselectLabel="Нажмите, снять выделение"
                        label="operator_name"
                        track-by="operator_uuid"
                    ></multiselect>
                </b-form-group>
            </div>

            <div class="col-sm-12 col-xl-12" v-show="languages_option.length > 0">
                <b-form-group
                    label="Язык"
                    label-for="language"
                >
                    <multiselect
                        id="language"
                        v-model="language"
                        :options="languages_option"
                        placeholder="Выберите из списка"
                        selectLabel="Нажмите, чтобы выбрать"
                        deselectLabel="Нажмите, снять выделение"
                        label="name"
                        :track-by="trackBy"
                    ></multiselect>
                </b-form-group>
            </div>

            <div class="col-sm-12 col-xl-12">
                <b-form-checkbox v-model="$parent.stt_params.literature" name="literature" style="margin-top: 5px; margin-bottom: 20px" switch>
                    Литературный стиль
                </b-form-checkbox>
            </div>
        </div>

        <!-- <div class="row">
            <div class="col-sm-12 col-xl-12">
                <b-form-checkbox v-show="$parent.record.async_action && $parent.stt_params.async_action" v-model="$parent.stt_params.delayed" name="config_stt_params" style="margin-top: 15px; margin-bottom: 5px" switch>
                    Отложенное распознавание
                </b-form-checkbox>
            </div>
        </div>

        <div v-show="$parent.record.async_action && $parent.stt_params.async_action && $parent.stt_params.delayed" class="row" style="margin-top: 15px">
            <div class="col-sm-12 col-xl-12">
                <b-form-group
                    label="Время отложенного распознавания, сек"
                    label-for="stt_params_variable_name"
                >
                    <b-form-input
                        id="stt_params_variable_name"
                        v-model="$parent.stt_params.delayed_time"
                    ></b-form-input>
                </b-form-group>
            </div>
        </div> -->

    </div>
</template>
